import { useState } from 'react';

export default function Support() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'How does KVADRUM VPN protect my privacy?',
      answer: 'KVADRUM VPN uses military-grade AES-256 encryption to secure all your internet traffic. We maintain a strict zero-log policy, meaning we never track, collect, or store your browsing history, connection logs, or any personal data. Your online activity remains completely private and anonymous.'
    },
    {
      question: 'Can I use KVADRUM VPN on multiple devices?',
      answer: 'Yes! A single KVADRUM VPN subscription allows you to protect up to 5 devices simultaneously. You can use it on Windows, macOS, iOS, Android, and Linux devices. All your devices will be secured under one account.'
    },
    {
      question: 'Will using a VPN slow down my internet speed?',
      answer: 'While VPNs can slightly reduce speed due to encryption overhead, KVADRUM VPN is optimized for performance. Our global network of high-speed servers ensures minimal impact on your connection. Most users experience no noticeable difference in their browsing, streaming, or downloading speeds.'
    },
    {
      question: 'What is your refund policy?',
      answer: 'We offer a 30-day money-back guarantee. If you\'re not completely satisfied with KVADRUM VPN for any reason, simply contact our support team within 30 days of purchase for a full refund, no questions asked.'
    },
    {
      question: 'Can I access streaming services with KVADRUM VPN?',
      answer: 'Absolutely! KVADRUM VPN allows you to access your favorite streaming platforms from anywhere in the world. Our servers are optimized for streaming, providing fast, buffer-free access to content libraries across different regions.'
    },
    {
      question: 'Is KVADRUM VPN legal to use?',
      answer: 'Yes, using a VPN is legal in most countries. KVADRUM VPN is a legitimate privacy tool designed to protect your online security and freedom. However, we encourage users to comply with local laws and the terms of service of websites they visit.'
    }
  ];

  const quickLinks = [
    { icon: 'ri-book-open-line', text: 'Documentation', href: '#' },
    { icon: 'ri-video-line', text: 'Video Tutorials', href: '#' },
    { icon: 'ri-team-line', text: 'Community Forum', href: '#' },
    { icon: 'ri-mail-line', text: 'Email Support', href: '#' }
  ];

  return (
    <section id="support" className="py-24 lg:py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-5 gap-12">
          <div className="lg:col-span-3">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-12">
              Frequently Asked Questions
            </h2>

            <div className="space-y-0">
              {faqs.map((faq, index) => (
                <div key={index} className="border-b border-gray-200">
                  <button
                    onClick={() => setOpenIndex(openIndex === index ? null : index)}
                    className="w-full py-8 flex items-center justify-between text-left group cursor-pointer"
                  >
                    <span className="text-lg font-bold text-gray-900 pr-8 group-hover:text-teal-600 transition-colors">
                      {faq.question}
                    </span>
                    <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                      <i className={`${openIndex === index ? 'ri-subtract-line' : 'ri-add-line'} text-2xl text-teal-600 transition-transform`}></i>
                    </div>
                  </button>
                  
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      openIndex === index ? 'max-h-96 pb-8' : 'max-h-0'
                    }`}
                  >
                    <p className="text-base text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="lg:sticky lg:top-32">
              <div className="bg-white rounded-3xl p-10 shadow-lg">
                <h3 className="text-2xl font-bold text-gray-900 mb-8">
                  Need More Help?
                </h3>

                <div className="space-y-6">
                  {quickLinks.map((link, index) => (
                    <a
                      key={index}
                      href={link.href}
                      className="group flex items-center justify-between p-4 rounded-xl hover:bg-gray-50 transition-colors cursor-pointer"
                    >
                      <div className="flex items-center space-x-4">
                        <div className="w-10 h-10 flex items-center justify-center bg-teal-50 rounded-lg group-hover:bg-teal-100 transition-colors">
                          <i className={`${link.icon} text-xl text-teal-600`}></i>
                        </div>
                        <span className="text-base font-medium text-gray-900">
                          {link.text}
                        </span>
                      </div>
                      <i className="ri-arrow-right-line text-xl text-gray-400 group-hover:text-teal-600 group-hover:translate-x-1 transition-all"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
